module.exports = __webpack_public_path__ + "static/media/loader.5c5ee73e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/loader.gif
// module id = ./src/common/images/loader.gif
// module chunks = 1